// import './shim.js'
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './utils/store';
import { installTokenAudit } from './apiTools/tokenAudit';
import App from './App';
import 'semantic-ui-css/semantic.css';
import 'font-awesome/css/font-awesome.css';
import 'react-datepicker/dist/react-datepicker.css';
import './styles/datepicker-fluid.css';

/**
 * ⚠️ BEFORE ANYTHING ELSE, AND TEMPORARY. Records who writes `authToken` while an unexplained
 * production failure is being chased — a good token replaced by an expired one a minute after
 * login. It has to be installed before the first render, because the first thing many pages do is
 * read or clear the token. Console: `readTokenWrites()`. See apiTools/tokenAudit.js, which also
 * says how to remove it.
 */
installTokenAudit();

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);